import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { ROLE_LABELS } from "../constants";

/**
 * UserSidebar
 * Componente que renderiza a lista de usuários da plataforma no painel lateral do layout Master-Detail.
 * Shape alinhado com o backend: fullName, platformRole, position.
 */
const UserSidebar = ({
    users = [],
    activeId,
    onSelect,
    onCreateNew,
    loading
}) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar usuários baseado na pesquisa local
    const filteredUsers = users.filter((user) => {
        const name = user.fullName || user.name || "";
        const email = user.email || "";
        return name.toLowerCase().includes(searchQuery.toLowerCase()) || 
               email.toLowerCase().includes(searchQuery.toLowerCase());
    });

    // Mapear usuários para o formato padrão do NeoSideMenu
    const sideMenuItems = filteredUsers.map((user) => {
        const label = user.fullName || user.name || "Sem Nome";
        const roleLabel = ROLE_LABELS[user.platformRole] || user.platformRole || "";
        
        let badge = null;
        let badgeVariant = null;
        if (user.status === "inactive") {
            badge = "Bloqueado";
            badgeVariant = "danger";
        }

        return {
            id: user.id,
            label: label,
            description: `${user.position || "Sem Cargo"} • ${roleLabel}`,
            photoUrl: user.photoUrl || null,
            icon: "mdi-account-outline",
            badge,
            badgeVariant
        };
    });

    return (
        <NeoSideMenu
            title="Equipe Interna"
            subtitle={`${users.length} cadastrados`}
            icon="mdi-account-group-outline"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const usr = users.find((u) => u.id === id);
                if (usr) onSelect(usr);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar colaborador..."
                />
            }
        />
    );
};

UserSidebar.propTypes = {
    users: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default UserSidebar;
